import { connect } from 'react-redux';
import Input from './Input';

const mapStateToProps = ({ form }, ownProps) => {
  const currentFormName = ownProps.meta.form;
  const currentFormValues =
    (form[currentFormName] && form[currentFormName].values) || [];

  const currentlyActiveFormField = form[currentFormName]
    ? form[currentFormName].active
    : false;

  return {
    form,
    isActiveField: ownProps.input.name === currentlyActiveFormField,
    isFilled: Object.keys(currentFormValues).includes(ownProps.input.name),
    isSelected:
      ownProps.input.value === true || ownProps.input.checked === true,
  };
};

export default connect(mapStateToProps)(Input);
